import { subDays, toDate } from "date-fns";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { defaultQuestionResultStatuses, setLeadsNotSnoozedFilters, useLeadsNotSnoozedFilters } from "modules/LeadsDashboard/Leads/NotSnoozedLeads/hooks";
import { LEADS_NOT_SNOOZED_STORAGE_KEYS } from "modules/LeadsDashboard/storageKeys";
import { PAGE_SIZE, setPreference } from "utils/common";

import type { DealersLocationsDropdownValue } from "components";

export const useNotSnoozedFilterHandlers = () => {
  const { selectedLocation } = useSelectedLocation();
  const filters = useLeadsNotSnoozedFilters();

  const handleTagsChange = (value: number[]) => {
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.TagsPreference, value);
    setLeadsNotSnoozedFilters({ ...filters, tags: value, page: 1 });
  };
  const handleSearchChange = (value: string) => setLeadsNotSnoozedFilters({ ...filters, search_term: value, page: 1 });
  const handleResetFilters = () => {
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.DealerPreference, []);
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.RegVinPreference, null);
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.TagsPreference, null);
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.QuestionStatusPreference, defaultQuestionResultStatuses);
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.InterventionQuestionResultPreference, null);
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.LocationPreference, selectedLocation?.id ? [selectedLocation.id] : []);
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.CustomerApprovedPreference, false);
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.InterventionsPreference, false);
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25);

    setLeadsNotSnoozedFilters({
      ...filters,
      page: 1,
      dealer_ids: [],
      search_term: "",
      is_lease_company: null,
      date_from: subDays(new Date(), 30),
      date_to: toDate(new Date()),
      location_ids: selectedLocation?.id ? [selectedLocation.id] : [],
      customer_approved: false,
      interventions: false,
      statuses: defaultQuestionResultStatuses,
      questions: null,
      tags: null,
      page_size: PAGE_SIZE.PageSize25
    });
  };
  const handleInterventionsChange = () => {
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.InterventionsPreference, !filters.interventions);
    setLeadsNotSnoozedFilters({ ...filters, interventions: !filters.interventions, page: 1 });
  };

  const handleCustomerApprovedChange = () => {
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.CustomerApprovedPreference, !filters.customer_approved);
    setLeadsNotSnoozedFilters({ ...filters, customer_approved: !filters.customer_approved, page: 1 });
  };

  const handleDealerLocationChange = ({ dealerIds, locationIds }: DealersLocationsDropdownValue) => {
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.DealerPreference, dealerIds);
    setPreference(LEADS_NOT_SNOOZED_STORAGE_KEYS.LocationPreference, locationIds);
    setLeadsNotSnoozedFilters({ ...filters, dealer_ids: dealerIds, location_ids: locationIds, questions: null, page: 1 });
  };

  return {
    handleTagsChange,
    handleResetFilters,
    handleSearchChange,
    handleInterventionsChange,
    handleDealerLocationChange,
    handleCustomerApprovedChange
  };
};
